export const CollectionsRoute = {
  path: '/accounting/collections',
  load: () => import('./CollectionDetails'),
  protected: true,
};
